module.exports = __webpack_public_path__ + "static/media/2.37b8bb28.JPG";